import {
  Configuration,
  ConfigurationParameters,
} from "@/openapi-ts/configuration";
import {
  AssignmentApiFactory,
  AssessmentAnalysisApiFactory,
  AuthApiFactory,
  CourseApiFactory,
  EditorListApiFactory,
  EventApiFactory,
  LeaderboardApiFactory,
  ScoreApiFactory,
  StudentListApiFactory,
  SubmissionApiFactory,
  WorkbookConfigApiFactory,
  VimeoVideosApiFactory,
  QuizzesApiFactory,
  QuizSubmissionsApiFactory,
  QuizCoursesApiFactory,
  VideoStatsApiFactory,
  ProgressReportsApiFactory,
  ForumRecordsApiFactory,
  GkeApiFactory,
  AssessmentsApiFactory,
} from "@/openapi-ts";
import { DefaultApiFactory } from "@/openapi-workbook-builder-ts";
import axios from "axios";

// axios interceptor will take care of jwt
const axiosClient = axios;

// Django main backend apis
const ilectBackendConfigurationParameter: ConfigurationParameters = {
  basePath: import.meta.env.VITE_APP_BACKEND_API_ENDPOINT,
};
const ilectBackendConfiguration = new Configuration(
  ilectBackendConfigurationParameter,
);

export const authApi = AuthApiFactory(
  ilectBackendConfiguration,
  undefined,
  axiosClient,
);
export const assignmentApi = AssignmentApiFactory(
  ilectBackendConfiguration,
  undefined,
  axiosClient,
);
export const courseApi = CourseApiFactory(
  ilectBackendConfiguration,
  undefined,
  axiosClient,
);
export const editorListApi = EditorListApiFactory(
  ilectBackendConfiguration,
  undefined,
  axiosClient,
);
export const studentListApi = StudentListApiFactory(
  ilectBackendConfiguration,
  undefined,
  axiosClient,
);
export const eventApi = EventApiFactory(
  ilectBackendConfiguration,
  undefined,
  axiosClient,
);
export const forumRecordsApi = ForumRecordsApiFactory(
  ilectBackendConfiguration,
  undefined,
  axiosClient,
);
export const leaderboardApi = LeaderboardApiFactory(
  ilectBackendConfiguration,
  undefined,
  axiosClient,
);
export const scoreApi = ScoreApiFactory(
  ilectBackendConfiguration,
  undefined,
  axiosClient,
);
export const submissionApi = SubmissionApiFactory(
  ilectBackendConfiguration,
  undefined,
  axiosClient,
);
export const workbookConfigApi = WorkbookConfigApiFactory(
  ilectBackendConfiguration,
  undefined,
  axiosClient,
);
export const assessmentAnalysisApi = AssessmentAnalysisApiFactory(
  ilectBackendConfiguration,
  undefined,
  axiosClient,
);
export const assessmentApi = AssessmentsApiFactory(
  ilectBackendConfiguration,
  undefined,
  axiosClient,
);
export const VimeoVideosApi = VimeoVideosApiFactory(
  ilectBackendConfiguration,
  undefined,
  axiosClient,
);
export const VideoStatsApi = VideoStatsApiFactory(
  ilectBackendConfiguration,
  undefined,
  axiosClient,
);

// Workbook Builder apis
const ilectBuilderConfigurationParameter: ConfigurationParameters = {
  basePath: import.meta.env.VITE_APP_BUILDER_API_ENDPOINT,
};
const ilectBuilderConfiguration = new Configuration(
  ilectBuilderConfigurationParameter,
);

export const workbookApi = DefaultApiFactory(
  ilectBuilderConfiguration,
  undefined,
  axiosClient,
);

export const quizzesAPI = QuizzesApiFactory(
  ilectBuilderConfiguration,
  undefined,
  axiosClient,
);

export const quizCoursesAPI = QuizCoursesApiFactory(
  ilectBuilderConfiguration,
  undefined,
  axiosClient,
);

export const quizSubmissionsAPI = QuizSubmissionsApiFactory(
  ilectBuilderConfiguration,
  undefined,
  axiosClient,
);

export const progressReportsAPI = ProgressReportsApiFactory(
  ilectBuilderConfiguration,
  undefined,
  axiosClient,
);

export const gkeStatsAPI = GkeApiFactory(
  ilectBuilderConfiguration,
  undefined,
  axiosClient,
);
